module.exports = __webpack_public_path__ + "img/vector.0a3b9539.svg";